/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */
import type {
  BattleIngameRetry200,
  BattleRandomList200,
  BattleRandomRefresh200,
  BattleStart200,
  CatRunnerAdCompleteRequest,
  CatRunnerAdStartRequest,
  CatRunnerAdminReloadResponse,
  CatRunnerBattleIngameRetryRequest,
  CatRunnerBattleRefreshRequest,
  CatRunnerBattleStartRequest,
  CatRunnerPlayContinueRequest,
  CatRunnerPlayEndRequest,
  CatRunnerPlayItemReuseRequest,
  CatRunnerPlayRoundRequest,
  CatRunnerPlayStartRequest,
  CompleteAd3200,
  MyWeeklyRanking200,
  MyWeeklyRankingParams,
  PlayContinue200,
  PlayEnd200,
  PlayForfeit1200,
  PlayItemReuse200,
  PlayStart2200,
  RecentPlayHistory200,
  RecentPlayHistoryParams,
  StartAd3200,
  State2200,
  WeeklyRanking200,
  WeeklyRankingParams,
} from '.././model';

/**
 * @summary 캣러닝 싱글 플레이 시작(하트/간식 차감·시드 발급)
 */
export type playStart2Response200 = {
  data: PlayStart2200;
  status: 200;
};

export type playStart2ResponseSuccess = playStart2Response200 & {
  headers: Headers;
};
export type playStart2Response = playStart2ResponseSuccess;

export const getPlayStart2Url = () => {
  return `/cat-runner/play/start`;
};

export const playStart2 = async (
  catRunnerPlayStartRequest: CatRunnerPlayStartRequest,
  options?: RequestInit,
): Promise<playStart2Response> => {
  const res = await fetch(getPlayStart2Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerPlayStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playStart2Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playStart2Response;
};

/**
 * @summary 캣러닝 인게임 아이템 재사용(간식 또는 광고)
 */
export type playItemReuseResponse200 = {
  data: PlayItemReuse200;
  status: 200;
};

export type playItemReuseResponseSuccess = playItemReuseResponse200 & {
  headers: Headers;
};
export type playItemReuseResponse = playItemReuseResponseSuccess;

export const getPlayItemReuseUrl = () => {
  return `/cat-runner/play/item/reuse`;
};

export const playItemReuse = async (
  catRunnerPlayItemReuseRequest: CatRunnerPlayItemReuseRequest,
  options?: RequestInit,
): Promise<playItemReuseResponse> => {
  const res = await fetch(getPlayItemReuseUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerPlayItemReuseRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playItemReuseResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playItemReuseResponse;
};

/**
 * @summary 캣러닝 라운드 포기
 */
export type playForfeit1Response200 = {
  data: PlayForfeit1200;
  status: 200;
};

export type playForfeit1ResponseSuccess = playForfeit1Response200 & {
  headers: Headers;
};
export type playForfeit1Response = playForfeit1ResponseSuccess;

export const getPlayForfeit1Url = () => {
  return `/cat-runner/play/forfeit`;
};

export const playForfeit1 = async (
  catRunnerPlayRoundRequest: CatRunnerPlayRoundRequest,
  options?: RequestInit,
): Promise<playForfeit1Response> => {
  const res = await fetch(getPlayForfeit1Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerPlayRoundRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playForfeit1Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playForfeit1Response;
};

/**
 * @summary 캣러닝 플레이 종료(거리·츄르 정산·포인트 지급)
 */
export type playEndResponse200 = {
  data: PlayEnd200;
  status: 200;
};

export type playEndResponseSuccess = playEndResponse200 & {
  headers: Headers;
};
export type playEndResponse = playEndResponseSuccess;

export const getPlayEndUrl = () => {
  return `/cat-runner/play/end`;
};

export const playEnd = async (
  catRunnerPlayEndRequest: CatRunnerPlayEndRequest,
  options?: RequestInit,
): Promise<playEndResponse> => {
  const res = await fetch(getPlayEndUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerPlayEndRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playEndResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playEndResponse;
};

/**
 * @summary 캣러닝 이어하기(간식 1개, +30m 웜업)
 */
export type playContinueResponse200 = {
  data: PlayContinue200;
  status: 200;
};

export type playContinueResponseSuccess = playContinueResponse200 & {
  headers: Headers;
};
export type playContinueResponse = playContinueResponseSuccess;

export const getPlayContinueUrl = () => {
  return `/cat-runner/play/continue`;
};

export const playContinue = async (
  catRunnerPlayContinueRequest: CatRunnerPlayContinueRequest,
  options?: RequestInit,
): Promise<playContinueResponse> => {
  const res = await fetch(getPlayContinueUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerPlayContinueRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playContinueResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playContinueResponse;
};

/**
 * @summary 랜덤 배틀 시작(간식 차감·고스트 상대 매칭)
 */
export type battleStartResponse200 = {
  data: BattleStart200;
  status: 200;
};

export type battleStartResponseSuccess = battleStartResponse200 & {
  headers: Headers;
};
export type battleStartResponse = battleStartResponseSuccess;

export const getBattleStartUrl = () => {
  return `/cat-runner/battle/start`;
};

export const battleStart = async (
  catRunnerBattleStartRequest: CatRunnerBattleStartRequest,
  options?: RequestInit,
): Promise<battleStartResponse> => {
  const res = await fetch(getBattleStartUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerBattleStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: battleStartResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as battleStartResponse;
};

/**
 * @summary 랜덤 배틀 상대 리프레시(일 1회 무료, 이후 광고)
 */
export type battleRandomRefreshResponse200 = {
  data: BattleRandomRefresh200;
  status: 200;
};

export type battleRandomRefreshResponseSuccess = battleRandomRefreshResponse200 & {
  headers: Headers;
};
export type battleRandomRefreshResponse = battleRandomRefreshResponseSuccess;

export const getBattleRandomRefreshUrl = () => {
  return `/cat-runner/battle/random/refresh`;
};

export const battleRandomRefresh = async (
  catRunnerBattleRefreshRequest: CatRunnerBattleRefreshRequest,
  options?: RequestInit,
): Promise<battleRandomRefreshResponse> => {
  const res = await fetch(getBattleRandomRefreshUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerBattleRefreshRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: battleRandomRefreshResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as battleRandomRefreshResponse;
};

/**
 * @summary 배틀 인게임 재도전(간식 1개 또는 광고, 게임당 1회)
 */
export type battleIngameRetryResponse200 = {
  data: BattleIngameRetry200;
  status: 200;
};

export type battleIngameRetryResponseSuccess = battleIngameRetryResponse200 & {
  headers: Headers;
};
export type battleIngameRetryResponse = battleIngameRetryResponseSuccess;

export const getBattleIngameRetryUrl = () => {
  return `/cat-runner/battle/ingame-retry`;
};

export const battleIngameRetry = async (
  catRunnerBattleIngameRetryRequest: CatRunnerBattleIngameRetryRequest,
  options?: RequestInit,
): Promise<battleIngameRetryResponse> => {
  const res = await fetch(getBattleIngameRetryUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerBattleIngameRetryRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: battleIngameRetryResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as battleIngameRetryResponse;
};

/**
 * @summary 캣러닝 광고 시작
 */
export type startAd3Response200 = {
  data: StartAd3200;
  status: 200;
};

export type startAd3ResponseSuccess = startAd3Response200 & {
  headers: Headers;
};
export type startAd3Response = startAd3ResponseSuccess;

export const getStartAd3Url = () => {
  return `/cat-runner/ads/start`;
};

export const startAd3 = async (
  catRunnerAdStartRequest: CatRunnerAdStartRequest,
  options?: RequestInit,
): Promise<startAd3Response> => {
  const res = await fetch(getStartAd3Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerAdStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: startAd3Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as startAd3Response;
};

/**
 * @summary 캣러닝 광고 완료
 */
export type completeAd3Response200 = {
  data: CompleteAd3200;
  status: 200;
};

export type completeAd3ResponseSuccess = completeAd3Response200 & {
  headers: Headers;
};
export type completeAd3Response = completeAd3ResponseSuccess;

export const getCompleteAd3Url = () => {
  return `/cat-runner/ads/complete`;
};

export const completeAd3 = async (
  catRunnerAdCompleteRequest: CatRunnerAdCompleteRequest,
  options?: RequestInit,
): Promise<completeAd3Response> => {
  const res = await fetch(getCompleteAd3Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(catRunnerAdCompleteRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: completeAd3Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as completeAd3Response;
};

/**
 * @summary 캣러닝 설정 캐시 리로드
 */
export type reloadConfig2Response200 = {
  data: CatRunnerAdminReloadResponse;
  status: 200;
};

export type reloadConfig2ResponseSuccess = reloadConfig2Response200 & {
  headers: Headers;
};
export type reloadConfig2Response = reloadConfig2ResponseSuccess;

export const getReloadConfig2Url = () => {
  return `/cat-runner/admin/config/reload`;
};

export const reloadConfig2 = async (options?: RequestInit): Promise<reloadConfig2Response> => {
  const res = await fetch(getReloadConfig2Url(), {
    ...options,
    method: 'POST',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: reloadConfig2Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as reloadConfig2Response;
};

/**
 * @summary 캣러닝 상태 조회
 */
export type state2Response200 = {
  data: State2200;
  status: 200;
};

export type state2ResponseSuccess = state2Response200 & {
  headers: Headers;
};
export type state2Response = state2ResponseSuccess;

export const getState2Url = () => {
  return `/cat-runner/state`;
};

export const state2 = async (options?: RequestInit): Promise<state2Response> => {
  const res = await fetch(getState2Url(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: state2Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as state2Response;
};

/**
 * @summary 캣러닝 주간 랭킹(기본 상위 30명)
 */
export type weeklyRankingResponse200 = {
  data: WeeklyRanking200;
  status: 200;
};

export type weeklyRankingResponseSuccess = weeklyRankingResponse200 & {
  headers: Headers;
};
export type weeklyRankingResponse = weeklyRankingResponseSuccess;

export const getWeeklyRankingUrl = (params?: WeeklyRankingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/cat-runner/ranking/weekly?${stringifiedParams}`
    : `/cat-runner/ranking/weekly`;
};

export const weeklyRanking = async (
  params?: WeeklyRankingParams,
  options?: RequestInit,
): Promise<weeklyRankingResponse> => {
  const res = await fetch(getWeeklyRankingUrl(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: weeklyRankingResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as weeklyRankingResponse;
};

/**
 * @summary 캣러닝 주간 내 순위
 */
export type myWeeklyRankingResponse200 = {
  data: MyWeeklyRanking200;
  status: 200;
};

export type myWeeklyRankingResponseSuccess = myWeeklyRankingResponse200 & {
  headers: Headers;
};
export type myWeeklyRankingResponse = myWeeklyRankingResponseSuccess;

export const getMyWeeklyRankingUrl = (params?: MyWeeklyRankingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/cat-runner/ranking/weekly/me?${stringifiedParams}`
    : `/cat-runner/ranking/weekly/me`;
};

export const myWeeklyRanking = async (
  params?: MyWeeklyRankingParams,
  options?: RequestInit,
): Promise<myWeeklyRankingResponse> => {
  const res = await fetch(getMyWeeklyRankingUrl(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: myWeeklyRankingResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as myWeeklyRankingResponse;
};

/**
 * @summary 캣러닝 최근 플레이 기록(기본 10건, 최신순)
 */
export type recentPlayHistoryResponse200 = {
  data: RecentPlayHistory200;
  status: 200;
};

export type recentPlayHistoryResponseSuccess = recentPlayHistoryResponse200 & {
  headers: Headers;
};
export type recentPlayHistoryResponse = recentPlayHistoryResponseSuccess;

export const getRecentPlayHistoryUrl = (params?: RecentPlayHistoryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/cat-runner/history/recent?${stringifiedParams}`
    : `/cat-runner/history/recent`;
};

export const recentPlayHistory = async (
  params?: RecentPlayHistoryParams,
  options?: RequestInit,
): Promise<recentPlayHistoryResponse> => {
  const res = await fetch(getRecentPlayHistoryUrl(params), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: recentPlayHistoryResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as recentPlayHistoryResponse;
};

/**
 * @summary 랜덤 배틀 상대 목록(오늘 3슬롯)
 */
export type battleRandomListResponse200 = {
  data: BattleRandomList200;
  status: 200;
};

export type battleRandomListResponseSuccess = battleRandomListResponse200 & {
  headers: Headers;
};
export type battleRandomListResponse = battleRandomListResponseSuccess;

export const getBattleRandomListUrl = () => {
  return `/cat-runner/battle/random`;
};

export const battleRandomList = async (options?: RequestInit): Promise<battleRandomListResponse> => {
  const res = await fetch(getBattleRandomListUrl(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: battleRandomListResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as battleRandomListResponse;
};
